import { ReactNode } from 'react';
import styles from './styles/AttributeRow.module.scss';
import cn from 'classnames';

interface AttributeRowProps {
  title: ReactNode;
  children: ReactNode;
  blue?: boolean;
}

export default function AttributeRow({ title, children, blue }: AttributeRowProps) {
  return (
    <div className={styles.Row}>
      <div className={styles.Title}>{title}</div>
      <div className={cn(styles.Value, { [styles.Blue]: blue })}>{children}</div>
    </div>
  );
}
